import { useState, useEffect } from 'react';
import { servicesService } from '../services/api';
import { ServiceModal } from '../components/ServiceModal';
import './Services.css';

const LOCATION_LABEL = { in_person: 'In person', phone: 'Phone', video: 'Video', client_location: "Client's place" };

export default function Services() {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState(null); // { service } | { create: true }

  async function load() {
    setLoading(true);
    const res = await servicesService.getAll();
    if (res.success) setServices(res.services || []);
    setLoading(false);
  }
  useEffect(() => { load(); }, []);

  async function remove(e, s) {
    e.stopPropagation();
    if (!window.confirm(`Delete "${s.name}"?`)) return;
    await servicesService.delete(s.id);
    load();
  }

  return (
    <div className="services-page">
      <div className="page-header">
        <h1 className="page-title">My Meeting Types</h1>
        <button className="btn btn-primary" onClick={() => setModal({ create: true })}>+ New Meeting Type</button>
      </div>

      {loading ? (
        <div className="empty-state"><div className="loading-spinner"></div></div>
      ) : services.length === 0 ? (
        <div className="empty-state"><p>No meeting types yet. Add one so clients can book with you.</p></div>
      ) : (
        <div className="card-grid">
          {services.map((s) => (
            <div key={s.id} className={`service-card ${s.is_active ? '' : 'inactive'}`} onClick={() => setModal({ service: s })}>
              <div className="service-card-head">
                <h3>{s.name}</h3>
                <span className="service-duration">{s.duration_minutes} min</span>
              </div>
              {s.description && <p className="text-muted service-desc">{s.description}</p>}
              <div className="service-meta">
                <span className="chip">{LOCATION_LABEL[s.location_mode] || s.location_mode}</span>
                {s.price ? <span className="chip">${s.price}</span> : <span className="chip">Free</span>}
                {!s.is_public && <span className="chip chip-muted">Hidden</span>}
                {!s.is_active && <span className="chip chip-muted">Inactive</span>}
              </div>
              <button className="btn btn-sm btn-outline service-delete" onClick={(e) => remove(e, s)}>Delete</button>
            </div>
          ))}
        </div>
      )}

      <ServiceModal isOpen={!!modal} onClose={() => setModal(null)} onSave={() => { setModal(null); load(); }} service={modal?.service || null} />
    </div>
  );
}
